<template>
  <el-drawer
    v-model="isShowDialog"
    :direction="direction"
    :before-close="handleClose"
    :with-header="false"
    size="35%"
    destroy-on-close
  >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="急救记录" name="record">
        <record :patient="patient"/>
      </el-tab-pane>
      <el-tab-pane label="语音识别" name="recognition">
        <recognition :recognition-text="recognitionText"/>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import Record from "@/components/Drawers/Live/Record";
import Recognition from "@/components/Drawers/Live/Recognition";

export default {
  name: "MyDrawer",
  components: {
    Record,
    Recognition
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    patient: {
      type: Object,
      default() {
        return {};
      }
    },
    recognitionText: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["closeDrawer"],
  data() {
    return {
      direction: "rtl",
      activeName: "record",
      isShowDialog: false
    };
  },
  watch: {
    drawer: {
      handler(val) {
        this.isShowDialog = val;
      },
      immediate: true
    }

  },
  methods: {
    handleClose() {
      this.$emit("closeDrawer");
    },
    handleClick(tab, event) {
    },
  }
};
</script>

<style scoped lang="scss">
.el-drawer {
  color: blue;
}

::v-deep {
  #pane-record {
    overflow-y: auto;
    height: 814px;
    padding-right: 10px;
  }

  .el-tabs__nav {
    width: 100%;

    height: 44px;
    border: 1px solid #CCCCCC !important;
    border-radius: 10px !important;
  }

  .el-tabs__header {
    text-align: center;
    height: 44px;
    border: none;
    margin-bottom: 35px;

    .el-tabs__item {
      width: 50%;
      height: 44px;
      font-size: 18px;
      color: #333333;
    }

    .el-tabs__item.is-active {
      background: #2AA5E3;
      color: #FBFBFB;
    }

    .el-tabs__item.is-active:first-child {
      border-radius: 10px 0 0 10px;
    }

    .el-tabs__item.is-active:last-child {
      border-radius: 0 10px 10px 0;
    }
  }
}
</style>
